// extracted by mini-css-extract-plugin
module.exports = {"message":"PostFeed_message__26-S1","search":"PostFeed_search__2iaJo","return":"PostFeed_return__23ChS"};